import React from "react";

import PropTypes from "prop-types";

import { TitleSmall } from "Cobalt/Header";
import { CarrierLogo } from "Common/CarrierLogo";
import { Span } from "Common/HTML";

import type { MedicalPlan, DentalPlan, VisionPlan, LifePlan } from "Utils/types";

type Props = {
  button?: React.ReactNode;
  plan: MedicalPlan | DentalPlan | VisionPlan | LifePlan;
};

const PlanHeader = ({ plan, button }: Props) => (
  <TitleSmall>
    <CarrierLogo plan={plan} maxSize={3} />
    <Span>
      {plan.display_name}
      {button}
    </Span>
  </TitleSmall>
);

export default PlanHeader;

PlanHeader.propTypes = {
  button: PropTypes.object,
};
